//this class has been created to provide common functions across modules
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { RootScopeData } from '../rootscope-data';

import { RootScopeService } from '../shared-service/root-scope.service';
import { RootScopeDeclare } from '../rootscope-declare';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { FacilityService } from '../services/facility.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class CommonUtil {
  rootScopeData: RootScopeDeclare;
  constructor(
    public trans: TranslateService,
    private rootScopeService: RootScopeService,
    private router: Router,
    private titleService: Title,
    private _facilityService: FacilityService
  ) {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  // retrieves the text with given key from json
  public translateText(key: any): any {
    let translatedText = this.trans.instant(key);
    return translatedText;
  }

  //retrieves the text with given key  from json and replace the # with given value

  public replaceValueAsHTMLOnTranslatedText(key: any, values: Array<string>): any {
    let translatedText: string;
    translatedText = this.trans.instant(key);
    values.forEach(function (value) {
      translatedText = translatedText.replace('#', value);
    });
    return translatedText;
  }

  //removes leading and trailing white spaces in string
  public trimText(str: string): string {
    return str ? str.replace(/^\s+|\s+$/gm, '') : '';
  }

  public localizeDate(ts: number | Date, isTimeIncluded?: boolean): string {
    let formatteddate: string;
    let d: Date;
    if (typeof isTimeIncluded === 'undefined') {
      isTimeIncluded = true;
    }
    if (!ts) return '';
    let monNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    if (!(ts instanceof Date) && !isNaN(ts)) {
      ts = Number(ts);
    }
    d = new Date(ts);
    let hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours(); //hours in military time format
    let mins = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
    let transMth = 'MTH.' + monNames[d.getMonth()];
    if (RootScopeData.selectedLang == 'ar' || RootScopeData.selectedLang == 'he') {
      formatteddate = d.getDate() + ' ' + this.trans.instant(transMth) + ' ' + d.getFullYear();
      if (isTimeIncluded) formatteddate = formatteddate + ', ' + hours + ':' + mins; //Removed AM and PM (military time)
    } else if (RootScopeData.selectedLang == 'zhl') {
      formatteddate =
        d.getFullYear() +
        this.trans.instant('YEAR') +
        (d.getMonth() + 1) +
        this.trans.instant('MONTH') +
        d.getDate() +
        this.trans.instant('DATE.FORMAT'); //Removed AM and PM (military time)
    } else {
      formatteddate = this.trans.instant(transMth) + ' ' + d.getDate() + ', ' + d.getFullYear();
      if (isTimeIncluded) formatteddate = formatteddate + ', ' + hours + ':' + mins; //Removed AM and PM (military time)
    }
    return formatteddate;
  }

  public convertToLocalDateFormat(timemillis: Date) {
    let pipe = new DatePipe(this.rootScopeData.selectedLang);
    const myFormattedDate = pipe.transform(timemillis, this.getFormatBasedOnLang());
    return myFormattedDate;
  }

  public getFormatBasedOnLang() {
    if (
      this.rootScopeData.selectedLang == 'ar' ||
      this.rootScopeData.selectedLang == 'ca' ||
      this.rootScopeData.selectedLang == 'fr' ||
      this.rootScopeData.selectedLang == 'he' ||
      this.rootScopeData.selectedLang == 'it'
    ) {
      return 'dd/MM/yy';
    } else if (
      this.rootScopeData.selectedLang == 'cy' ||
      this.rootScopeData.selectedLang == 'en_US' ||
      this.rootScopeData.selectedLang == 'eu' ||
      this.rootScopeData.selectedLang == 'zhl'
    ) {
      return 'M/d/yy';
    } else if (
      this.rootScopeData.selectedLang == 'de' ||
      this.rootScopeData.selectedLang == 'en' ||
      this.rootScopeData.selectedLang == 'ru'
    ) {
      return 'dd.MM.yy';
    } else if (this.rootScopeData.selectedLang == 'es') {
      return 'd/MM/yy';
    } else if (this.rootScopeData.selectedLang == 'fi') {
      return 'd.M.yyyy';
    } else if (this.rootScopeData.selectedLang == 'hu') {
      return 'yyyy.MM.dd';
    } else if (this.rootScopeData.selectedLang == 'ja') {
      return 'yy/MM/dd';
    } else if (this.rootScopeData.selectedLang == 'ko') {
      return 'yy.M.d';
    } else if (this.rootScopeData.selectedLang == 'nl') {
      return 'd-M-yy';
    } else if (this.rootScopeData.selectedLang == 'pl') {
      return 'yy-MM-dd';
    } else if (this.rootScopeData.selectedLang == 'pt') {
      return 'dd-MM-yyyy';
    } else if (this.rootScopeData.selectedLang == 'tr') {
      return 'dd.MM.yyyy';
    } else if (this.rootScopeData.selectedLang == 'zh') {
      return 'yy-M-d';
    } else {
      return 'M/d/yy';
    }
  }

  public getFormattedFacilityHours(facSummary: any): string {
    let exactHrs = '';
    if (facSummary.facilityHoursStart == '0' && facSummary.facilityHoursEnd == '24') {
      exactHrs = '24 hours';
    } else {
      let facHourStart = this.addZeroInTheFront(facSummary.facilityHoursStart.toString(), 'String');
      let facHourEnd = this.addZeroInTheFront(facSummary.facilityHoursEnd.toString(), 'String');
      let minStart = this.addZeroInTheFront(facSummary.facilityMinsStart.toString(), 'String');
      let minEnd = this.addZeroInTheFront(facSummary.facilityMinsEnd.toString(), 'String');
      exactHrs = facHourStart + ':' + minStart + ' - ' + facHourEnd + ':' + minEnd;
    }
    let gmthrs = '';
    if (facSummary.timezoneName != null) {
      let timeZoneValue = facSummary.timezoneName.substr(0, 10);
      gmthrs = ' (' + timeZoneValue + ')';
    } else {
      let d = new Date();
      let offsethrs = Math.floor(-d.getTimezoneOffset() / 60);
      let offsetmins = Math.abs(-d.getTimezoneOffset() % 60);
      gmthrs =
        ' (GMT ' +
        this.addZeroInTheFront(offsethrs, 'Number') +
        ':' +
        this.addZeroInTheFront(offsetmins.toString(), 'String') +
        ')';
    }
    return exactHrs + gmthrs;
  }

  redirectBasedOnAuthentication(): void {
    if (this.rootScopeData.isAuthenticated && localStorage.getItem('isLoggedIn') !== 'true') {
      localStorage.setItem('isLoggedIn', 'true');
      if (localStorage.getItem('userRequestedURL') != null) {
        this.router
          .navigate([localStorage.getItem('userRequestedURL')])
          .then((data) => {
            this.router.navigate([localStorage.getItem('userRequestedURL')]);
          })
          .catch((e) => {
            window.location.href = <string>localStorage.getItem('userRequestedURL');
          });
      } else this.redirectToAvailablePage();
    } else if (
      !this.rootScopeData.isAuthenticated &&
      (localStorage.getItem('isLoggedIn') === 'true' || localStorage.getItem('isLoggedIn') === null)
    ) {
      localStorage.setItem('userRequestedURL', this.router.url);
      localStorage.setItem('isLoggedIn', 'false');
      this.router.navigate(['/landing']);
    }
  }

  redirectToAvailablePage(): void {
    let routePath = "";
    const _selectedFacility = this._facilityService.selectedFacility();
    if (_selectedFacility['summary']) {
      if (_selectedFacility.summary.facilityRights.home != 'true') {
        if (this.router.url.indexOf('/facility/') === -1) {
          routePath = '/facility/manage';                  
        }
      } else {
        routePath = '/dashboard';
      }
    } else {
      let mgrType = localStorage.getItem('vtManagerType');
      if (mgrType != null && mgrType === 'N') {
        routePath = '/facility/manage';
      } else {
        routePath = '/dashboard';
      }
    }

    if(routePath){
      setTimeout(() => {
        this.router.navigate([routePath]);
      }); 
    }   
  }

  softwareRedirectToFacility(page: string): void {
    const _selectedFacility = this._facilityService.selectedFacility();
    if (_selectedFacility['summary']) {
      const fr = _selectedFacility.summary.facilityRights;
      if (
        (fr.software == 'false' && page == 'software') ||
        (fr.remoteSoftware == 'false' && page == 'remote-update') ||
        (fr.lifescapeCourse == 'false' && page == 'life-scape-course')
      ) {
        this.redirectToAvailablePage();
      }
    }
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  /*check for empty object */
  public isEmpty = (obj: any) => {
    return obj === null || undefined
      ? true
      : (() => {
        for (const prop in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            return false;
          }
        }
        return true;
      })();
  };

  public addZeroInTheFront(val: any, type: string): string {
    if (type == 'String') {
      if (val.length < 2) {
        val = '0' + val;
      }
    } else {
      if (Math.abs(val) <= 9 && val.toString().length == 2) {
        val = val.toString();
        val.split('').splice(1, 0, '0').join('');
        //val = insertAt(val, 1, '0');
      } else if (Math.abs(val) <= 9 && val.toString().length < 2) {
        val = val.toString();
        val = '+0' + val;
      } else if (Math.abs(val) > 9 && val.toString().length == 2) {
        val = val.toString();
        val = '+' + val;
      }
    }
    return val;
  }

  public openOnNewTab(url: string) {
    let winRef = window.open(url, "_blank");
    if (!winRef) {
      this.rootScopeData.isShowPopupBlockerMessage = true;
    }
  }

  public capitalizeWord(str: string): string {
    if (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
    return '';
  }

  public scrollTop() {
    const elmnt = <HTMLElement>document.getElementById('page-cntr');
    elmnt.scrollTop = 0;
  }

  public scrollToView(elementIdSelector: string) {
    setTimeout(() => {
      const element = <HTMLElement>document.getElementById(elementIdSelector);
      const pageCntrElement = <HTMLElement>document.getElementById('page-cntr');
      pageCntrElement.scrollTop = element.getBoundingClientRect().top - 50;
    }, 1000);
  }


  public isBrowser() {
    var test = function (regexp: RegExp) {
      return regexp.test(window.navigator.userAgent);
    };
    switch (true) {
      case test(/edg/i):
        return 'edge';
      case test(/opr/i) && (!!(window as any)['opr'] || !!(window as any)['opera']):
        return 'opera';
      case test(/chrome/i) && !!(window as any)['chrome']:
        return 'chrome';
      case test(/trident/i):
        return 'ie';
      case test(/firefox/i):
        return 'firefox';
      case test(/safari/i):
        return 'safari';
      default:
        return 'other';
    }
  }

  public imgSrcGenerate(modelId: string, console: string, isLarge?: boolean) {
    if (!String(console)) {
      console = 'discover';
    }
    let sConsoleIdList = ['184', '185', '186','187'];
    let dConsoleIdList = ['180', '181', '182', '183'];
    let sOrD = sConsoleIdList.indexOf(String(modelId)) !== -1 ? 'S_' : dConsoleIdList.indexOf(String(modelId)) !== -1 ? 'D_' : '';
    return `${environment.cloudBasePath}/Products/Product_${String(console) != 'explorer' ? String(console).toUpperCase() : 'ZEUS'
      }_${sOrD}${String(modelId)}${isLarge ? '_394x292.png' : '_50x50.png'}`;
  }

  public imgSrcConsole(console: string) {
    return `${environment.cloudBasePath}/Products/Console_${console != 'explorer' ? console.toUpperCase() : 'ZEUS'
      }_59x49.png`;
  }

  public isEmail(mail: string) {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(mail);
  }

  navigatePage(path: string[]) {
    if(this.rootScopeData.isPageHasUnsavedChanges) {
      this.rootScopeData.pathToNavigate = path;
      this.rootScopeData.showUnSavedChangesModal = true;
    } 
    else this.router.navigate(path);
  }
}
